import React, { useRef, useEffect } from 'react'
import { IonContent } from '@ionic/react'
import { useLocation } from 'react-router-dom'

const bottomPaths = ['/home', '/category', '/cart', '/user']

export default ({ children }) => {
    const ref = useRef()
    const location = useLocation()
    useEffect(() => {
        const styles = document.createElement('style')
        if (!bottomPaths.some((x) => location.pathname.includes(x))) {
            document.querySelector('ion-tab-bar[slot="bottom"]').style.height = '0px'
        } else {
            document.querySelector('ion-tab-bar[slot="bottom"]').style.height = '50px'
        }

        styles.textContent = `
            ::-webkit-scrollbar {
                width: 0px;
            }
        `
        ref.current?.shadowRoot.appendChild(styles)
    }, [location.pathname])

    return (
        <IonContent fullscreen ref={ref}>
            {children}
        </IonContent>
    )
}
